/* eslint-disable no-shadow,no-param-reassign */
import {
  deletePartner,
  createNewPartner,
  editPartner,
  fetchPartners,
  fetchEmailMappings,
  createEmailMapping,
  editEmailMapping,
  deleteEmailMapping,
  fetchCurrencies,
  createCurrency,
  deleteCurrency,
  fetchAllCurrencies,
  fetchPartnerIbans,
  syncPartnerIbans,
  fetchPaymentTypes,
  createPaymentType,
  editPaymentType,
  deletePaymentType,
  fetchCountries,
  createCountry,
  editCountry,
  deleteCountry,
  getWhitelist,
  createWhitelist,
  updateWhitelist,
  fetchDocumentIssuers,
  createDocumentIssuer,
  updateDocumentIssuer,
  deleteDocumentIssuer,
} from '../../services/api';

const state = {
  partners: [],
  partnerIbans: [],
  paymentTypes: [],
  emailMappings: [],
  currencies: [],
  allCurrencies: [],
  countries: [],
  currentWhitelist: null,
  documentIssuers: [],
};

const getters = {
  partners: (state) => state.partners,
  partnerIbans: (state) => state.partnerIbans,
  paymentTypes: (state) => state.paymentTypes,
  emailMappings: (state) => state.emailMappings,
  currencies: (state) => state.currencies,
  allCurrencies: (state) => state.allCurrencies,
  countries: (state) => state.countries,
  currentWhitelist: (state) => state.currentWhitelist,
  documentIssuers: (state) => state.documentIssuers,
};

const mutations = {
  setPartners(state, payload) {
    state.partners = payload;
  },
  addPartner(state, payload) {
    state.partners.push(payload);
  },
  removePartner(state, payload) {
    state.partners = state.partners.filter((item) => item.url !== payload.url);
  },
  editPartner(state, payload) {
    const item = state.partners.find((item) => item.url === payload.url);
    Object.assign(item, payload);
  },
  setPartnerIbans(state, payload) {
    state.partnerIbans = payload;
  },
  setPaymentTypes(state, payload) {
    state.paymentTypes = payload;
  },
  addPaymentType(state, payload) {
    state.paymentTypes.push(payload);
  },
  editPaymentType(state, payload) {
    const item = state.paymentTypes.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },
  removePaymentType(state, payload) {
    state.paymentTypes = state.paymentTypes.filter((item) => item.id !== payload.id);
  },
  setEmailMappings(state, payload) {
    state.emailMappings = payload;
  },
  addEmailMapping(state, payload) {
    state.emailMappings.push(payload);
  },
  editEmailMapping(state, payload) {
    const item = state.emailMappings.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },
  removeEmailMapping(state, payload) {
    state.emailMappings = state.emailMappings.filter((item) => item.id !== payload.id);
  },
  setAllCurrencies(state, payload) {
    state.allCurrencies = payload;
  },
  setCurrencies(state, payload) {
    state.currencies = payload;
  },
  addCurrency(state, payload) {
    state.currencies.push(payload);
  },
  removeCurrency(state, payload) {
    state.currencies = state.currencies.filter((item) => item.id !== payload.id);
  },
  setCountries(state, payload) {
    state.countries = payload;
  },
  addCountry(state, payload) {
    state.countries.push(payload);
  },
  editCountry(state, payload) {
    const item = state.countries.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },
  removeCountry(state, payload) {
    state.countries = state.countries.filter((item) => item.id !== payload.id);
  },
  setWhitelist(state, payload) {
    state.currentWhitelist = payload;
  },
  setDocumentIssuers(state, payload) {
    state.documentIssuers = payload;
  },
  addDocumentIssuer(state, payload) {
    state.documentIssuers.push(payload);
  },
  updateDocumentIssuer(state, payload) {
    const index = state.documentIssuers.findIndex((item) => item.id === payload.id);
    if (index !== -1) {
      state.documentIssuers.splice(index, 1, payload);
    }
  },
  removeDocumentIssuer(state, payload) {
    state.documentIssuers = state.documentIssuers.filter((item) => item.id !== payload.id);
  },
};

const actions = {
  async getPartnersAction({ commit }, payload) {
    try {
      const { data } = await fetchPartners(payload);
      commit('setPartners', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createPartnerAction({ commit }, payload) {
    try {
      const { data } = await createNewPartner(payload);
      commit('addPartner', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async editPartnerAction({ commit }, payload) {
    try {
      const { data } = await editPartner(payload);
      commit('editPartner', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async removePartnerAction({ commit }, payload) {
    try {
      await deletePartner(payload);
      commit('removePartner', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================== whitelists ===================
  async getWhitelistAction({ commit }, id) {
    try {
      const { data } = await getWhitelist(id);
      commit('setWhitelist', data);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async createWhitelistAction({ commit }, payload) {
    try {
      const { data } = await createWhitelist(payload);
      commit('setWhitelist', data);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async updateWhitelistAction({ commit }, { id, payload }) {
    try {
      const { data } = await updateWhitelist(id, payload);
      commit('setWhitelist', data);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // ================= email mappings =================
  async getEmailMappingsAction({ commit }, payload) {
    try {
      const { data } = await fetchEmailMappings(payload);
      commit('setEmailMappings', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createEmailMappingAction({ commit }, payload) {
    try {
      const { data } = await createEmailMapping(payload);
      commit('addEmailMapping', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async editEmailMappingAction({ commit }, payload) {
    try {
      const { data } = await editEmailMapping(payload);
      commit('editEmailMapping', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async removeEmailMappingAction({ commit }, payload) {
    try {
      await deleteEmailMapping(payload.id);
      commit('removeEmailMapping', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================/ email mappings =================

  // ================= currencies =================
  async getAllCurrenciesAction({ commit }, payload) {
    try {
      const { data } = await fetchAllCurrencies();
      commit('setAllCurrencies', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getCurrenciesAction({ commit }, payload) {
    try {
      const { data } = await fetchCurrencies();
      commit('setCurrencies', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createCurrencyAction({ commit }, payload) {
    try {
      const { data } = await createCurrency(payload);
      commit('addCurrency', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async removeCurrencyAction({ commit }, payload) {
    try {
      await deleteCurrency(payload.id);
      commit('removeCurrency', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================/ currencies =================

  // ================= IBANs =================
  async getPartnerIbansAction({ commit }) {
    try {
      const { data } = await fetchPartnerIbans();
      commit('setPartnerIbans', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async syncPartnerIbansAction({ commit }) {
    try {
      const { data } = await syncPartnerIbans();
      commit('setPartnerIbans', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================/ IBANs =================
  // ================= Payment types =================
  async getPaymentTypesAction({ commit }) {
    try {
      const { data } = await fetchPaymentTypes();
      commit('setPaymentTypes', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createPaymentTypeAction({ commit }, payload) {
    try {
      const { data } = await createPaymentType(payload);
      commit('addPaymentType', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async editPaymentTypeAction({ commit }, payload) {
    try {
      const { data } = await editPaymentType(payload);
      commit('editPaymentType', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async removePaymentTypeAction({ commit }, payload) {
    try {
      await deletePaymentType(payload.id);
      commit('removePaymentType', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================/ Payment types =================

  // ================= Countries =================
  async getCountriesAction({ commit }, payload) {
    try {
      const { data } = await fetchCountries();
      commit('setCountries', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createCountryAction({ commit }, payload) {
    try {
      const { data } = await createCountry(payload);
      commit('addCountry', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async editCountryAction({ commit }, payload) {
    try {
      const { data } = await editCountry(payload);
      commit('editCountry', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async removeCountryAction({ commit }, payload) {
    try {
      await deleteCountry(payload.id);
      commit('removeCountry', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  // =================/ Countries =================
  // ================= Document Issuers =================
  async getDocumentIssuersAction({ commit }, params = {}) {
    try {
      const { data } = await fetchDocumentIssuers(params);
      commit('setDocumentIssuers', data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async createDocumentIssuerAction({ commit }, payload) {
    try {
      const { data } = await createDocumentIssuer(payload);
      commit('addDocumentIssuer', data);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateDocumentIssuerAction({ commit }, payload) {
    try {
      const { data } = await updateDocumentIssuer(payload);
      commit('updateDocumentIssuer', data);
      return data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteDocumentIssuerAction({ commit }, payload) {
    try {
      await deleteDocumentIssuer(payload.id);
      commit('removeDocumentIssuer', payload);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  // =================/ Document Issuers =================
};

export default {
  state,
  getters,
  mutations,
  actions,
};
